import React from "react"
import Zoopass from "../Components/Zoopass/Zoopass"
import { useAccount } from "../Contexts/AccountContext"

export default () => {
    const { memberships, currentMembership, dictionary } = useAccount();

    return <div>
        {memberships && currentMembership && <Zoopass membership={currentMembership}/>}
        {!memberships && <div className="alert alert-default bg-white">
            <h4 className="alert-heading">{dictionary.get("MyAccount:Membership:ZooPass:Loading") ?? "Loading Zoo Passes..." }</h4>
            <p>{ dictionary.get("MyAccount:Membership:ZooPass:LoadingDescription") ?? "Please wait while we load your information."}</p>
        </div>}
        {memberships && !currentMembership && <div className="alert alert-default bg-white">
            <h4 className="alert-heading">{dictionary.get("MyAccount:Membership:ZooPass:NotFound") ?? "No Zoo Passes Found"}</h4>
            <p>{dictionary.get("MyAccount:Membership:ZooPass:NotFoundDescription") ?? "You do not have any zoo passes at this time."}  <a title="Purchase a Pass" href={window.zooPassUrl}>{dictionary.get("MyAccount:Membership:ZooPass:PurchaseAPass") ?? "Purchase a Pass"}</a></p>
        </div>}
    </div>
}